import React, { useState, useEffect } from 'react'
import './../styles/ticTacToe.css';
import TicTacToeBoard from '../TicTacToeBoard';
import GameNav from '../GameNav';


const TicTacToe = () => {

    const gameCharacters = [
        '/images/tic-tac-toe-1.png',
        '/images/tic-tac-toe-2.png',
        '/images/tic-tac-toe-3.png',
        '/images/tic-tac-toe-4.png',
        '/images/tic-tac-toe-5.png',
        '/images/tic-tac-toe-6.png',
        '/images/tic-tac-toe-7.png',
        '/images/tic-tac-toe-8.png'
    ]
    const [optionsDisplay, toggleOptionsDisplay] = useState(true);
    const [characterDisplay, setCharachterDisplay] = useState(false);

    const [availableCharacters, setAvailableCharacters] = useState(gameCharacters);

    const [characterOne, setCharacterOne] = useState(null);
    const [characterTwo, setCharacterTwo] = useState(null);

    const [currentPlayerSelect, setCurrentPlayerSelect] = useState(1);

    const hideDisplayOptions = () => {
        toggleOptionsDisplay(false);
    }

    const showDisplayOptions = () => {
        toggleOptionsDisplay(true);
    }

    const handleCharacterDisplay = () => {
        setCharachterDisplay(true);
    }

    const hideCharacterDisplay = () => {
        setCharachterDisplay(false);
    }

    const [mode, gameMode] = useState(null)

    const playButtonSound = () => {
        const audio = new Audio('/sounds/button-sound.mp3');
        audio.volume = 0.2;
        audio.play();
    }

    const setSingleGameMode = () => {
        playButtonSound();
        gameMode(1);
        hideDisplayOptions();
        handleCharacterDisplay();
    }

    const setTwoPlayerGameMode = () => {
        playButtonSound();
        gameMode(2);
        hideDisplayOptions();
        handleCharacterDisplay();
    }


    const setCpuPlayer = (selectedIndex) => {
        // const remainingCharacters = availableCharacters.filter((_, i) => i !== selectedIndex);
        // const cpuCharacter = remainingCharacters[Math.floor(Math.random() * remainingCharacters.length)];
        // setCharacterTwo(cpuCharacter);

        // handleCharacterDisplay();

        const remainingCharacters = availableCharacters.filter(char => char !== characterOne);
        const cpuCharacter = remainingCharacters[Math.floor(Math.random() * remainingCharacters.length)];
        setCharacterTwo(cpuCharacter);
        hideCharacterDisplay();

    }

    useEffect(() => {
        if (mode === 1 && characterOne && currentPlayerSelect === 2) {
            setCpuPlayer();
        }
    }, [mode, characterOne, currentPlayerSelect]);




    const playerOneSelect = (index) => {
        const selectedCharacter = availableCharacters[index];
        setCharacterOne(selectedCharacter);

        const remainingCharacters = availableCharacters.filter((_, i) => i !== index);
        setAvailableCharacters(remainingCharacters);

        setCurrentPlayerSelect(2);

    }

    const playerTwoSelect = (index) => {
        if (mode === 2) {

            const selectedCharacter = availableCharacters[index];
            setCharacterTwo(selectedCharacter);
            hideCharacterDisplay()
        }

    }


    const logging = () => {
        console.log(`turn to select character: ${currentPlayerSelect}`);
        console.log(`characterOne ${characterOne}`);
        console.log(`characterTwo ${characterTwo}`);
        console.log(`character display: ${characterDisplay}`)
        console.log(`game mode ${mode}`)
    }

    logging();

    return (
        <div id='tic-tac-toe-main' >
            <GameNav />
            {optionsDisplay ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

                    <div id='modes'>
                        <h2>Select a Game Mode</h2>
                        <div className='mode-section'>
                            <div className='mode-btn' onClick={setSingleGameMode}>
                                <img src={process.env.PUBLIC_URL + '/images/single-player.png'} height='15px'></img>
                                <p>Single Player</p>
                            </div>
                            <div className='mode-btn' onClick={setTwoPlayerGameMode}>
                                <img src={process.env.PUBLIC_URL + '/images/double-player.png'} height='15px'></img>
                                <p>Two Player</p>
                            </div>
                        </div>
                    </div>

                </div>
            ) : characterDisplay ? (
                <div className="character-grid-outer">
                    {currentPlayerSelect === 1 ? (
                        <h1 className='characters-label'>Select Your Character Player One</h1>
                    ) : (
                        <h1 className='characters-label'>Select Your Character Player Two</h1>
                    )}
                    <div className='pick-character'>
                        {availableCharacters.map((character, index) => (
                            currentPlayerSelect === 1 ? (
                                <div
                                    onClick={() => playerOneSelect(index)}  // Wrap the function in an anonymous function
                                    className="character-container"
                                    key={index}>
                                    <img src={`${process.env.PUBLIC_URL}${character}`} alt={`Character ${index + 1}`} />
                                </div>

                            ) : (

                                <div
                                    onClick={() => playerTwoSelect(index)}  // Wrap the function in an anonymous function
                                    className="character-container"
                                    key={index}>
                                    <img src={`${process.env.PUBLIC_URL}${character}`} alt={`Character ${index + 1}`} />
                                </div>
                            )

                        ))}

                    </div>
                </div>
            ) : (
                <div className='tic-tac-toe-game'>
                    <TicTacToeBoard setSingleGameMode={setSingleGameMode} setTwoPlayerGameMode={setTwoPlayerGameMode} mode={mode} characterOne={characterOne} characterTwo={characterTwo} hideCharacterDisplay={hideCharacterDisplay} showDisplayOptions={showDisplayOptions} />
                </div>
            )}

        </div>
    )

}

export default TicTacToe 